/**
* DevExpress HTML/JS Reporting (scopes\reporting-designer-widgets.js)
* Version:  24.1.7
* Build date: Oct 28, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import '../designer/controls/metadata/properties/dataBindings';
import '../designer/widgets/bandEditors';
import '../designer/widgets/chartValueBindingEditor';
import '../designer/widgets/customFunctions';
import '../designer/widgets/dataSourceEditor';
import '../designer/widgets/dataSourceSelectBox';
import '../designer/widgets/editOptionsEditor';
import '../designer/widgets/editorTemplates';
import '../designer/widgets/explorerEditors';
import '../designer/widgets/expressioneditor/reportExpressionEditorAdapter';
import '../designer/widgets/expressioneditor/reportExpressionEditor';
import '../designer/widgets/expressioneditor/reportComplexExpressionEditor';
import '../designer/widgets/expressionableFontEditor';
import '../designer/widgets/fieldsComboboxEditor';
import '../designer/widgets/formatStringEditor';
import '../designer/widgets/formattingRuleEditor';
import '../designer/widgets/gaugeStyleEditor';
import '../designer/widgets/groups';
import '../designer/widgets/imageSourceEditor';
import '../designer/widgets/linesEditor';
import '../designer/widgets/nameEditor';
import '../designer/widgets/watermarkIdEditor';
import '../designer/widgets/pivotGridCriteriaEditor';
import '../designer/widgets/propertyGridEditors';
import '../designer/widgets/expressioneditor/reportExpressionEditorWrapper';
import '../designer/widgets/reportFieldListEditor';
import '../designer/widgets/reportUrlEditor';
import '../designer/widgets/richTextFileEditor';
import '../designer/widgets/styleseditor';
import '../designer/widgets/summaryEditor';
import '../designer/widgets/undoEditors';
import { registerEditors } from '../designer/widgets/registerEditors';
registerEditors();
export * from '../designer/controls/metadata/properties/dataBindings';
export * from '../designer/widgets/bandEditors';
export * from '../designer/widgets/chartValueBindingEditor';
export * from '../designer/widgets/customFunctions';
export * from '../designer/widgets/dataSourceEditor';
export * from '../designer/widgets/dataSourceSelectBox';
export * from '../designer/widgets/editOptionsEditor';
export * from '../designer/widgets/editorTemplates';
export * from '../designer/widgets/explorerEditors';
export * from '../designer/widgets/expressioneditor/reportExpressionEditorAdapter';
export * from '../designer/widgets/expressioneditor/reportExpressionEditor';
export * from '../designer/widgets/expressioneditor/reportComplexExpressionEditor';
export * from '../designer/widgets/expressionableFontEditor';
export * from '../designer/widgets/fieldsComboboxEditor';
export * from '../designer/widgets/formatStringEditor';
export * from '../designer/widgets/formattingRuleEditor';
export * from '../designer/widgets/gaugeStyleEditor';
export * from '../designer/widgets/groups';
export * from '../designer/widgets/imageSourceEditor';
export * from '../designer/widgets/linesEditor';
export * from '../designer/widgets/nameEditor';
export * from '../designer/widgets/watermarkIdEditor';
export * from '../designer/widgets/pivotGridCriteriaEditor';
export * from '../designer/widgets/propertyGridEditors';
export * from '../designer/widgets/expressioneditor/reportExpressionEditorWrapper';
export * from '../designer/widgets/reportFieldListEditor';
export * from '../designer/widgets/reportUrlEditor';
export * from '../designer/widgets/richTextFileEditor';
export * from '../designer/widgets/styleseditor';
export * from '../designer/widgets/summaryEditor';
export * from '../designer/widgets/undoEditors';
